import { combineReducers } from "redux";
import {
  mobileReducer,
  storeReducer,
  storeFIlterReducer,
  categoryProductsReducer,
  cartOrderDetailsReducer,
  cartQuantityReducer,
  prescribeDataReducer,
} from "./Reducers";

export const rootReducer = combineReducers({
  mobileNumber: mobileReducer,
  storeDetails: storeReducer,
  storeFilter: storeFIlterReducer,
  categoryProducts: categoryProductsReducer,
  cartOrderDetails: cartOrderDetailsReducer,
  cartQuantity: cartQuantityReducer,
  prescribeData: prescribeDataReducer,
});
